import React from 'react';
import './index.scss';
import lupa from '../../img/busca.svg';

function IntelligenceSearch({
  bot,
  blt,
  newCard,
  onChangeFilter,
  filterText,
  user,
}) {
  return (
    <div>
      <div className="search">
        <div className="container-search-ia">
          <div className="container-btn">
            <button
              type="button"
              disabled={
                bot.iaEnabled
                  ? null
                  : 'disabled' ||
                    user?.selectedCompany?.claim?.name === 'Viewer'
              }
              className={[
                'btn-search',
                bot.iaEnabled ? '' : 'btn-disabled',
              ].join(' ')}
              onClick={
                user?.selectedCompany?.claim?.name !== 'Viewer' ? newCard : ''
              }
            >
              {blt === 'intencoes'
                ? 'criar nova intenção'
                : 'criar nova entidade'}
            </button>
          </div>
          <div className="container-input">
            <img src={lupa} alt="lupa" onClick={console.log(user)} />
            <input
              disabled={user?.selectedCompany?.claim?.name === 'Viewer'}
              className="inp-search"
              value={filterText}
              onChange={onChangeFilter}
              placeholder={
                blt === 'intencoes' ? 'Buscar intenções' : 'Buscar entidades'
              }
            />
          </div>
        </div>
        {/* <div className="container-opcoes" onClick={() => setOpcoesModal(!opcoesModal)}>
                    <img src={opcoes} alt="opcoes" style={{ cursor: 'pointer' }} />
                    <button className="btn-opcoes">Opções</button>
                </div>
                {opcoesModal === true &&
                    <div className="opcoes-modal">
                        <p style={{ marginBottom: 15 }}>Importar Intenções</p>
                        <p>Exportar Intenções</p>
                    </div>
                } */}
      </div>
    </div>
  );
}

export default IntelligenceSearch;
